var IntlTelInput = class extends HTMLElement {
    phoneInput = this.querySelector("input.phone"); 
    dateInput = $("input.birthdate"); 
    connectedCallback() {
        this.createIntlTelInput();
        (this.dateInput, this.phoneInput).addEventListener("keypress", e => this.checkIntlFilled(e));
        (this.dateInput, this.phoneInput).addEventListener("mouseleave", e =>  this.checkIntlFilled(e));
        (this.dateInput, this.phoneInput).addEventListener("blur", e => this.checkIntlFilled(e));
        this.dateInput[0].addEventListener("change", e => this.checkIntlFilled(e));
        
    }

    
    createIntlTelInput() {
        if (this.phoneInput) {
          
        window.intlTelInput(this.phoneInput, {
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
            initialCountry: "auto",
            geoIpLookup: function (callback) {
                fetch("https://ipapi.co/json")
                    .then(function (res) {
                        return res.json();
                    })
                    .then(function (data) {
                        callback(data.country_code);
                    })
                    .catch(function () {
                        callback("us");
                    });
            }
        });
      }
    }

    checkIntlFilled(e) {
        const el = $(e.currentTarget);
        if (el.hasClass('is-filled')) {
            el.parent().addClass('is-filled')
        } else { 
            el.parent().removeClass('is-filled')
        }
    } 

};
window.customElements.define("intl-tel-input", IntlTelInput);
     